import { Inject, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { InitWebviewService } from '../webview/webview-public-api';

@Injectable({
  providedIn: 'root'
})
export class MessagesCounterService {
  readonly onMessagesCounterUpdate: BehaviorSubject<number>;
  readonly onGeneralMessagesCounterUpdate: BehaviorSubject<number>;

  constructor(@Inject(InitWebviewService) private readonly webviewService: InitWebviewService) {
    this.onMessagesCounterUpdate = new BehaviorSubject<number>(0);
    this.onGeneralMessagesCounterUpdate = new BehaviorSubject<number>(0);
  }

  setMessagesCounter(counter: number): void {
    if (counter !== undefined) {
      this.onMessagesCounterUpdate.next(counter);
      this.webviewService.postEmbeddedMessage({
        messageType: 'messageCount',
        payload: counter
      });
    }
  }

  setGeneralMessagesCounter(counter: number): void {
    if (counter !== undefined) {
      this.onGeneralMessagesCounterUpdate.next(counter);
    }
  }

  resetGeneralMessagesCount(): void {
    const currentTotalMsgCount = this.onMessagesCounterUpdate.getValue();
    const diff = currentTotalMsgCount - this.getGeneralMessageCount();
    this.onMessagesCounterUpdate.next(diff);
    this.webviewService.postEmbeddedMessage({
      messageType: 'messageCount',
      payload: diff
    });
    this.onGeneralMessagesCounterUpdate.next(0);
  }

  getGeneralMessageCount(): number {
    return this.onGeneralMessagesCounterUpdate.getValue();
  }

}
